'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  COS_TEMPLATE_LAYOUT: null,
  INDUSTRY: null,
  COS_TEMPLATE_INTENT: null,
  COS_TEMPLATE_FEATURES: null,
  COS_TEMPLATE_CODING_TYPE: null,
  MODULE_COMPATIBILITY: null,
  MODULE_PURPOSE: null
});